<template>
  <!--dashboard main body start-->
  <div style="overflow-x: hidden;" class="mt-4">
    <div class="-content d-flex align-items-start flex-column">
      <div class="page-global-header px-0 w-100">
        <div class="row mx-0 justify-content-center">
          <div
            class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 offset-xl-3 offset-xxl-3"
          >
            <div class="global-searchbar">
              <form class="base-form" @submit.prevent>
                <div class="input-group">
                  <div class="input-group-text quotationBrown">
                     <img src="@/assets/images/system/file-icon.svg"/>
                  </div>
                  <input
                    v-model="form.search_field"
                    type="search"
                    name="globalSearch"
                    class="form-control"
                    placeholder="Search (Business name, client name, email, invoice number etc)"
                  />
                  <button type="submit" name="btnSearch" class="btn btn-quotationbrown">
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            class="col-sm-12 col-md-12 col-lg-12 col-xl-3 col-xxl-3 d-flex align-items-center justify-content-end"
            style="padding-right: 20px;"
          >
            <ul class="search-option-menu me-3">
              <li class="nav-item">
                <XlsToggle v-model="xlsView" title="Switch between XLS grid and default quotation list" />
              </li>
              <li class="nav-item sorting">
                <input
                  type="checkbox"
                  class="sorting-check"
                  id="btn-sorting"
                  autocomplete="off"
                  v-model="quotation_sorting_desc"
                  @change="changeOrder"
                />
                <label class="btn btn-sorting" for="btn-sorting"
                  ><span class="sr-only">Sort</span>
                </label>
              </li>
              <li class="nav-item"> 
                <router-link to="/add-quotation" class="nav-link circleNav"
                  ><i class="fa fa-plus"></i>
                </router-link>
              </li>
              <li class="nav-item dropdown">
                <a
                  href="#"
                  class="nav-link dropdown-toggle no-caret"
                  id="optionMore"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  ><i class="fa fa-ellipsis-v"></i>
                </a>
                <ul
                  class="dropdown-menu dropdown-menu-end _v1"
                  aria-labelledby="optionMore"
                >
                  <li>
                    <a class="dropdown-item" href="#" @click.prevent="generatePdf"
                      >PDF <i class="fa fa-envelope append"></i>
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="#" @click.prevent="generateExcel"
                      >Download Excel <i class="fa fa-download append"></i>
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="#" @click.prevent="generateZip"
                      >Download Zip <i class="fa fa-download append"></i>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>

        <div class="row mx-0">
          <div class="mt-3">
            <div class="global-filter-form">
              <form class="base-form form-xl">
                <div class="row g-2 d-flex justify-content-center">
                    <div class="col-sm-2">
                      <div class="form-floating">
                        <input
                          type="date"
                          name="datepick"
                          id="startDate"
                          class="form-control datepicker text-center text-danger radius-tr-0 radius-br-0 _3d-input chevron-circle"
                          v-model="form.start_date"
                          @change="searchData"
                          onfocus="this.showPicker()"
                          data-date-format="mm/dd/yyyy"
                        />
                        <label for="startDate" class="w-100 text-center"
                          >Start date</label
                        >
                      </div>
                    </div>

                  <div class="col-sm-2">
                    <div class="form-floating">
                      <input
                        type="date"
                        name="datepick"
                        id="endDate"
                        class="form-control datepicker text-center text-danger radius-tl-0 radius-bl-0 _3d-input chevron-circle"
                        v-model="form.end_date"
                        @change="searchData"
                        onfocus="this.showPicker()"
                        data-date-format="mm/dd/yyyy"
                      />
                      <label for="endDate" class="w-100 text-center"
                        >End date</label
                      >
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <select
                      class="form-select _3d-input text-black"
                      v-model="form.category"
                      @change="searchData"
                    >
                      <option selected="" disabled="" value="">
                        Select quotation category (all)
                      </option>
                      <option value="all">All</option>
                      <option value="sent">Sent</option>
                      <option value="approved">Approved</option>
                      <option value="rejected">Rejected</option>
                      <option value="expired">Expired</option>
                      <option value="draft">Draft</option>
                      <option value="void">Void</option>
                    </select>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="page-body custom-scroll">
        <div class="row mt-3 mx-0" v-if="!xlsView">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 offset-xl-3 offset-xxl-3">
            <div class="card-list-group">
              <!--repeatable block-->
              <div
                class="card card-horizontal-list quotationBrown mt-2 px-0 mb-2"
                v-for="(quotation, index) in filteredQuotations"
                :key="index"
              >
                <div class="card-body">
                  <div class="hover-slide">
                    <div class="form-check outliner">
                      <input class="form-check-input" type="checkbox" value="" />
                    </div>
                  </div>
                  <div class="card-content count-inline flex-shrink-0">
                    <ul class="label-list">
                      <li class="list-title"><span class="card-count">{{ index + 1 }}.</span>{{ quotation.client.business_name }}</li>
                      <li class="sub-title">QN: {{ quotation.quotation_number }}</li>
                      <li class="text-danger">
                        D: {{ $formatDate(quotation.quotation_date) }} -
                        {{ $formatDate(quotation.expiry_date) }}
                      </li>
                      <li>E: {{ quotation.client.email }}</li>
                    </ul>
                    <ul class="card-action-nav flex-start-horizontal mt-3">
                      <li class="nav-item" v-if="quotation.total_discount_amount != 0">
                        <a href="#" class="btn btn-secondary btn-sm"
                          ><i class="fas fa-percent"></i> Discount
                        </a>
                      </li>
                      <li
                        class="nav-item"
                        v-if="quotation.quotation_attachments.filename != 'N/A'"
                      >
                        <a
                          href="#"
                          class="btn btn-primary btn-sm"
                          data-bs-toggle="modal"
                          data-bs-target="#expenseFile"
                          @click="showDetails(quotation.quotation_number, 'file')"
                          ><i class="fa fa-paperclip"></i> File
                        </a>
                      </li>
                      <li class="nav-item ms-2" v-if="hasNote(quotation)">
                        <a
                          href="#"
                          class="btn btn-info btn-sm"
                          data-bs-toggle="modal"
                          data-bs-target="#expenseFile"
                          @click="showDetails(quotation.quotation_number, 'note')"
                          ><i class="fa fa-edit"></i> Note
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="card-footer has-action flex-shrink-1">
                  <div class="ellipsis-dropdown dropdown">
                    <el-dropdown @command="handleCommand">
                      <span class="el-dropdown-link">
                        <i class="fas fa-ellipsis-v text-white"></i>
                      </span>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <el-dropdown-item
                            :command="{ action: 'edit', id: quotation.quotation_number }"
                            ><i class="fa fa-edit"></i>Edit</el-dropdown-item
                          >
                          <el-dropdown-item
                            @click="
                              deleteData(quotation.quotation_id, quotation.client.client_id)
                            "
                            ><i class="fa fa-times text-danger"></i>
                            Delete</el-dropdown-item
                          >
                          <el-dropdown-item
                            @click="updateStatus(quotation.quotation_id, 'Approved')"
                          >
                            <i class="fa fa-check text-success"></i> Approved
                          </el-dropdown-item>
                          <el-dropdown-item
                            @click="updateStatus(quotation.quotation_id, 'Rejected')"
                          >
                            <i class="fa fa-ban text-danger"></i> Rejected
                          </el-dropdown-item>
                          <el-dropdown-item
                            @click="updateStatus(quotation.quotation_id, 'Void')"
                          >
                            <i class="fa fa-times-circle text-warning"></i> Void
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </div>
                  <ul class="log-status center">
                    <li
                      v-if="statusKey(quotation)"
                      class="list-item"
                      :class="statusKey(quotation)"
                    >
                      <a href="#" class="text-capitalize">
                        <i :class="statusIcon(quotation)"></i>
                        {{ statusKey(quotation) }}
                      </a>
                    </li>
                  </ul>
                  <div class="footer-list-wraper justify-content-end">
                    <ul class="footer-list _big">
                      <li>Amount</li>
                      <li class="count">
                        {{ $auth.user?.currency }} {{ quotation.total_amount_net }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3 mx-0" v-else>
          <div class="col-12 xls-grid-col">
            <ExcelGridView
              :columns="xlsColumns"
              :rows="xlsRows"
              :totals="xlsTotals"
              :currency-symbol="$auth.user?.currency || '£'"
              no-data-text="No quotations match the current filters."
              @cell-click="onXlsCellClick"
            />
          </div>
        </div>

        <div class="row mx-0 mt-5 mb-4" v-if="!xlsView">
          <div
            class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 offset-xl-3 offset-xxl-3"
          >
            <div class="d-flex justify-content-end">
              <div
                v-if="form.category === 'all' || form.category === 'sent'"
                class="card-totalCount card-totalCount--sent"
              >
                <div class="card-header">Total Sent</div>
                <div class="card-body">
                  {{ $auth.user?.currency || '£' }} {{ totalSent.toFixed(2) }}
                </div>
              </div>

              <div class="card-totalCount card-totalCount--approved ms-4">
                <div class="card-header">Total Amount</div>
                <div class="card-body">
                  {{ $auth.user?.currency || '£' }} {{ totalGross.toFixed(2) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--dashboard main body end-->

    <div
      class="modal fade mdl-messaging _info"
      id="expenseFile"
      aria-hidden="true"
      aria-labelledby="expenseFileLabel"
      tabindex="-1"
    >
      <div class="modal-dialog">
        <div class="modal-dialog-header">
          <div class="header-title">Expense preview</div>
        </div>
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body pt-0">
            <div class="message-card no-shadow m-1">
              <div class="abs-nav abs--tr me-n5">
                <ul class="nav flex-column">
                  <li class="nav-item">
                    <router-link
                      class="nav-link"
                      :to="'/edit-quotation/' + popup_data.quotation_number"
                      ><i class="fa fa-edit"></i>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#"><i class="fa fa-print"></i> </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#"><i class="fa fa-envelope"></i> </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link"><i class="fa fa-download"></i> </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link"><i class="fas fa-ban"></i> </a>
                  </li>
                </ul>
              </div>

              <div class="w-90">
                <ul class="list-group list-group--borderless list-group--compact">
                  <li class="list-group-item">
                    Quotation number: {{ popup_data.quotation_number }}
                  </li>
                  <li class="list-group-item">
                    Quotation date: {{ $formatDate(popup_data.quotation_date) }}
                  </li>
                  <li class="list-group-item">
                    Vendor name: {{ popup_data.business_name }}
                  </li>
                  <li class="list-group-item">Vendor email: {{ popup_data.email }}</li>
                  <li class="list-group-item">Name: {{ popup_data.name }}</li>
                  <li class="list-group-item d-flex justify-content-between">
                    <span
                      >Total Amount: {{ popup_data.currency_symbol }} 
                      {{ popup_data.total_amount_net }}</span
                    >
                  </li>
                </ul>
              </div>

              <div class="card card--curve-05rem mt-3" v-if="showNote == 'note'">
                <div class="card-body">
                  <p class="m-0">Note:</p>
                  <p class="m-0">
                    {{ popup_data.notes }}
                  </p>
                </div>
              </div>

              <div
                class="card card--curve-05rem mt-3 w-100 align-items-center justify-content-center"
                v-if="showNote == 'file'"
              >
                <div class="w-auto p-2">
                  <div
                    v-for="(images_quotation, key) in popup_data.quotation_attachments"
                    v-bind:key="'inv_img' + key"
                  >
                    <img :src="images_quotation.url" class="img-fluid" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--dashboard main body end-->
</template>
<script>
import { CURRENCY_LIST } from "../../config/url";
import {
  resolveExportFilename,
  unwrapExportUrl,
  downloadExportFromUrl,
  saveBlob,
  readBlobError,
  readRequestError,
  exportErrorMessage,
  EXPORT_PREFIX,
} from "@/utils/exportNaming";
import { resolveCurrencyCode } from "@/utils/currencyCode";
import XlsToggle from "@/components/partials/XlsToggle.vue";
import ExcelGridView from "@/components/partials/ExcelGridView.vue";

export default {
  name: "QuotationComponent",
  components: { XlsToggle, ExcelGridView },

  data() {
    return {
      loadingInstance: null,
      show_total_expense: 0,
      errorMessage: "",
      xlsView: false,
      quotation_server_data: [],
      expense_category: null,
      currency: null,
      payment_method: null,
      form: {
        search_field: "",
        start_date: "",
        category: "all",
        end_date: new Date().toISOString().split("T")[0],
      },
      expenses_preview: {
        id: "",
        expense_number: "",
        category: "",
        vendor: "",
        date: "",
        payment_method: "",
        note: "",
        currency_id: "",
        amount: "",
        image_url: [],
      },
      search: {
        date: "",
        category: "all",
        currency: "",
        payment_method: "",
      },
      showNote: false,
      file_data: "",
      file_popup: false,
      note_popup: false,
      quotation_sorting_desc: false,
      popup_data: {
        quotation_number: "",
        total_amount_net: "",
        total_amount_paid: "",
        quotation_attachments: "",
        business_name: "",
        email: "",
        name: "",
        notes: "",
        currency_symbol: "",
        quotation_date: "",
      },
    };
  },
  created() {},
  computed: {
    currencyOptions() {
      if (this.currency) {
        return this.currency.map((v) => {
          return {
            id: v.id,
            name: v.name,
            symbol: v.symbol,
          };
        });
      }
      return [];
    },
  },
  mounted() {
    // Set start date to six months before
    const currentDate = new Date();
    const sixMonthsBefore = new Date(currentDate);
    sixMonthsBefore.setMonth(currentDate.getMonth() - 6);
    this.form.start_date = sixMonthsBefore.toISOString().split("T")[0];
    this.fetchCurrency();
    this.searchData();
  },
  methods: {
    showLoading() {
      this.loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
        fullscreen: true,
      });
    },
    hideLoading() {
      this.loadingInstance.close();
    },
    handleCommand(command) {
      if (command.action === "edit") {
        // Navigate to the edit page
        this.$router.push(`/edit-quotation/${command.id}`);
      }
    },
    updateStatus(quotation_id, status) {
      this.showLoading();
      if (status == "Void") {
        this.$store
          .dispatch("quotation/quotationVoid", {
            quotation_id: quotation_id,
          })
          .then((res) => {
            if (res.data.status == 1) {
              // this.$toast.success("Fetch data Successful.");
            } else {
              throw new Error(res);
            }
          })
          .catch((err) => {
            console.log(err);
            this.$toast.error("Something went wrong. Please try again.");
          })
          .finally(() => {
            this.hideLoading();
          });
      } else {
        this.$store
          .dispatch("quotation/changeStatus", {
            quotation_id: quotation_id,
            status: status,
          })
          .then((res) => {
            if (res.data.status == 1) {
              // this.$toast.success("Fetch data Successful.");
            } else {
              throw new Error(res);
            }
          })
          .catch((err) => {
            console.log(err);
            this.$toast.error("Something went wrong. Please try again.");
          })
          .finally(() => {
            this.hideLoading();
          });
      }
    },

    validateForm() {
      if (!this.form.start_date) {
        this.errorMessage = "Start date is required";
        return false;
      }
      if (!this.form.end_date) {
        this.errorMessage = "End date is required";
        return false;
      }
      // if (!this.form.search_field) {
      //   this.errorMessage = "Search field is required";
      //   return false;
      // }
      // Additional validations can be added here, such as date format checks
      return true;
    },
    async searchData() {
      this.showLoading();
      this.quotation_server_data = [];
      const data = {
        from_date: this.form.start_date,
        to_date: this.form.end_date,
        category: this.form.category,
      };

      if (this.validateForm()) {
        await this.$store
          .dispatch("quotation/searchList", data)
          .then((res) => {
            if (res.data.status == 1) {
              this.quotation_server_data = res.data.response;
            } else {
              // If API provides message, show it. Otherwise fallback to generic.
              const errorMsg =
                res.data.message?.length > 0
                  ? res.data.message.join(", ")
                  : "Something went wrong. Please try again.";
              this.$toast.error(errorMsg);
              throw new Error(errorMsg);
            }
          })
          .catch((err) => {
            console.log(err);
            // Optional: avoid duplicate toast if already shown above
            // this.$toast.error("Something went wrong. Please try again.");
          })
          .finally(() => {
            this.hideLoading();
          });
      } else {
        this.hideLoading();
      }
    },
    async fetchCurrency() {
      this.currency = await this.axios
        .get(CURRENCY_LIST)
        .then(function (res) {
          return res.data.response;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    filterExpenses() {
      console.log(this.search);
    },
    deleteData(quotationId, client_id) {
      this.showLoading();
      this.$store
        .dispatch("quotation/deleteQuotation", {
          quotation_id: quotationId,
          client_id: client_id,
        })
        .then((res) => {
          //   console.log(res);
          if (res.status == 1) {
            this.$toast.success("Delete Successful.");
            this.$nextTick(() => {
              this.searchData();
            });
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    changeOrder() {
      if (this.quotation_sorting_desc) {
        // Sort data in descending order
        this.quotation_server_data.sort(
          (a, b) => new Date(b.quotation_date) - new Date(a.quotation_date)
        );
      } else {
        // Sort data in ascending order
        this.quotation_server_data.sort(
          (a, b) => new Date(a.quotation_date) - new Date(b.quotation_date)
        );
      }
    },
    showDetails(id, note) {
      this.$store
        .dispatch("quotation/getQuotationByNumber", { quotation_number: id })
        .then((res) => {
          if (res.data.status == 1) {
            this.showNote = note;
            const q = res.data.response;
            this.popup_data.quotation_number = q.quotation_number;
            this.popup_data.quotation_date = q.quotation_date;
            this.popup_data.total_amount_net = q.total_amount_net;
            this.popup_data.total_amount_paid = q.total_amount_paid;
            this.popup_data.quotation_attachments = q.quotation_attachments;
            this.popup_data.business_name = q.client?.business_name || "";
            this.popup_data.email = q.client?.email || "";
            this.popup_data.name = q.client?.name || "";
            const rawNote = q.notes || q.description || q.note || q.client?.notes || "";
            this.popup_data.notes = (rawNote && String(rawNote).trim().toUpperCase() !== "N/A") ? rawNote : "";
            this.popup_data.currency_symbol = q.currency?.symbol || "";
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    // The payload every quotation export endpoint takes. `from`/`to` go
    // alongside `start_date`/`end_date` because the server prefers the latter
    // but still falls back to the former.
    exportFilters() {
      return {
        start_date: this.form.start_date,
        end_date: this.form.end_date,
        from: this.form.start_date,
        to: this.form.end_date,
      };
    },
    // The quotation list has no currency filter, so the fallback name uses the
    // signed-in user's currency. Only reached when the server names nothing.
    exportCurrencyCode() {
      return resolveCurrencyCode(this.$store.state.auth.user?.currency_id);
    },
    async generateExcel() {
      this.showLoading();

      try {
        const res = await this.$store.dispatch("quotation/exportXlxs", this.exportFilters());

        const url = unwrapExportUrl(res.data);
        if (!url) {
          this.$toast.error("Download URL not found");
          return;
        }

        const filename = resolveExportFilename({
          fileName: res.data?.file_name,
          currencyCode: await this.exportCurrencyCode(),
          prefix: EXPORT_PREFIX.quotation,
          extension: "xlsx",
        });

        await downloadExportFromUrl(url, filename);
      } catch (err) {
        console.error(err);
        const message = await readRequestError(err);
        this.$toast.error(
          message ||
            exportErrorMessage(err, "Could not generate the Excel file. Please try again.")
        );
      } finally {
        this.hideLoading();
      }
    },
    async generatePdf() {
      this.showLoading();

      try {
        const res = await this.$store.dispatch("quotation/generatePdf", this.exportFilters());
        const blob = new Blob([res.data], { type: "application/pdf" });

        // Defence in depth: a failure should now always be non-2xx, but a JSON
        // body arriving as HTTP 200 would otherwise be saved as a broken .pdf.
        const serverError = await readBlobError(blob);
        if (serverError) {
          this.$toast.error(serverError);
          return;
        }

        saveBlob(
          blob,
          resolveExportFilename({
            headers: res.headers,
            currencyCode: await this.exportCurrencyCode(),
            prefix: EXPORT_PREFIX.quotation,
            extension: "pdf",
          })
        );
      } catch (err) {
        console.error(err);
        const message = await readRequestError(err);
        this.$toast.error(
          message || exportErrorMessage(err, "Could not generate the PDF. Please try again.")
        );
      } finally {
        this.hideLoading();
      }
    },
    async generateZip() {
      this.showLoading();

      try {
        const res = await this.$store.dispatch("quotation/generateZip", this.exportFilters());

        const zipUrl = unwrapExportUrl(res.data);
        if (!zipUrl) {
          this.$toast.error("Download URL not found");
          return;
        }

        const filename = resolveExportFilename({
          fileName: res.data?.file_name,
          currencyCode: await this.exportCurrencyCode(),
          prefix: EXPORT_PREFIX.quotation,
          extension: "zip",
        });

        await downloadExportFromUrl(zipUrl, filename);
      } catch (err) {
        console.error(err);
        const message = await readRequestError(err);
        this.$toast.error(
          message ||
            exportErrorMessage(err, "Could not generate the ZIP file. Please try again.")
        );
      } finally {
        this.hideLoading();
      }
    },
    // The API sends two status-ish fields: `quotation_type` only ever carries the
    // lifecycle stage (draft / sent / void), while `quotation_status` carries the
    // outcome the client gave us (approved / rejected). The badge has to agree
    // with the category filter, which searches on the outcome, so an approved
    // quotation must not keep showing "Sent" just because its type says so.
    statusKey(quotation) {
      const type = String(quotation.quotation_type ?? "").toLowerCase();
      const status = String(quotation.quotation_status ?? "").toLowerCase();

      // Voided or never issued - outranks anything the client may have answered.
      if (type == "void" || status == "void") return "void";
      if (type == "draft" || status == "draft") return "draft";

      // The client's answer, once we have one.
      if (["approved", "rejected", "expired", "pending"].includes(status)) return status;

      // Still awaiting an answer, so the validity date decides.
      if (this.isExpired(quotation.expiry_date)) return "expired";

      return type || status;
    },
    // Date-only comparison: the API sends yyyy-mm-dd, so building a Date from it
    // would land on UTC midnight and read as "past" for most of the expiry day in
    // any positive offset. A quotation expiring today is still valid.
    isExpired(expiryDate) {
      const match = String(expiryDate ?? "").match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (!match) return false;

      const [, year, month, day] = match;
      const expiry = new Date(+year, +month - 1, +day);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return expiry < today;
    },
    statusIcon(quotation) {
      const map = {
        approved: "fas fa-check-square",
        rejected: "fas fa-times-circle",
        expired: "fas fa-clock",
        pending: "fas fa-history",
        draft: "far fa-file-alt",
        void: "fas fa-ban",
        sent: "fas fa-paper-plane",
      };
      return map[this.statusKey(quotation)] || "";
    },
    xlsStatusColor(status) {
      const map = {
        approved: "xls-badge-green",
        pending: "xls-badge-orange",
        rejected: "xls-badge-red",
        sent: "xls-badge-blue",
        draft: "xls-badge-brown",
        void: "xls-badge-red",
        expired: "xls-badge-blue",
      };
      return map[(status || "").toLowerCase()] || "xls-badge-blue";
    },
    onXlsCellClick({ key, row }) {
      if (key === "note") this.showDetails(row._quotation_number, "note");
      if (key === "attachment") this.showDetails(row._quotation_number, "file");
    },
    hasNote(quotation) {
      if (!quotation) return false;
      const noteContent =
        quotation.notes ||
        quotation.description ||
        quotation.note ||
        quotation.client?.notes;
      return (
        noteContent != null &&
        String(noteContent).trim() !== "" &&
        String(noteContent).trim().toUpperCase() !== "N/A"
      );
    },
  },
  computed: {
    // The search box filters the loaded list in the browser (same policy as the
    // client list) - the API ignores a search term, so asking it to filter
    // returned nothing at all.
    filteredQuotations() {
      if (!this.form.search_field) return this.quotation_server_data;

      const query = this.form.search_field.toLowerCase();
      const has = (value) => String(value ?? "").toLowerCase().includes(query);

      return this.quotation_server_data.filter((quotation) => {
        const client = quotation.client || {};
        return (
          has(client.business_name) ||
          has(client.full_name) ||
          has(client.name) ||
          has(client.email) ||
          has(client.phone1) ||
          has(quotation.quotation_number) ||
          has(quotation.notes) ||
          has(quotation.description) ||
          has(quotation.note)
        );
      });
    },
    totalGross() {
      return this.filteredQuotations.reduce((sum, item) => {
        return sum + (parseFloat(item.total_amount_net) || 0);
      }, 0);
    },
    totalSent() {
      return this.filteredQuotations.reduce((sum, item) => {
        if (item.quotation_type?.toLowerCase() === "sent") {
          return sum + (parseFloat(item.total_amount_net) || 0);
        }
        return sum;
      }, 0);
    },
    totalApproved() {
      return this.filteredQuotations.reduce((sum, item) => {
        if (item.quotation_type?.toLowerCase() === "approved") {
          return sum + (parseFloat(item.total_amount_net) || 0);
        }
        return sum;
      }, 0);
    },
    // A rate only belongs in the header when every listed record shares it -
    // with mixed rates the "(20%)" would be wrong for some of the rows.
    xlsTaxLabel() {
      return (base, field) => {
        const rates = new Set(
          this.filteredQuotations.map((quotation) => parseFloat(quotation[field]) || 0)
        );
        return rates.size === 1 ? base + " (" + [...rates][0] + "%)" : base;
      };
    },
    xlsColumns() {
      return [
        { key: "no", label: "No.", align: "center" },
        { key: "quotation_date", label: "Quotation Date", align: "left", date: true },
        { key: "expiry_date", label: "Expiry Date", align: "left", date: true },
        { key: "quotation_number", label: "Quotation No.", align: "left" },
        { key: "client_name", label: "Client Name", align: "left", totalLabel: "Total" },
        { key: "amount", label: "Amount", align: "right", money: true, total: true },
        { key: "discount", label: "Discount", align: "right", money: true, total: true },
        { key: "sub_total", label: "Sub-total", align: "right", money: true, total: true },
        {
          key: "tax1",
          label: this.xlsTaxLabel("Tax/Vat 1", "vat_percent"),
          align: "right",
          money: true,
          total: true,
        },
        {
          key: "tax2",
          label: this.xlsTaxLabel("Tax/Vat 2", "tax1_percent"),
          align: "right",
          money: true,
          total: true,
        },
        { key: "total", label: "Total", align: "right", money: true, total: true },
        { key: "status", label: "Status", align: "center", fill: true },
        { key: "note", label: "Note", align: "center", link: true },
        { key: "attachment", label: "Attachment", align: "center", link: true },
      ];
    },
    xlsRows() {
      return this.filteredQuotations.map((quotation, index) => {
        const hasNote = this.hasNote(quotation);
        const hasFile =
          quotation.quotation_attachments &&
          quotation.quotation_attachments.filename !== "N/A";
        // Same resolved status as the card badge, so both views never disagree.
        const status = this.statusKey(quotation);
        // `sub_total` is already net of the discount, so the pre-discount
        // amount has to be added back for the row to read left to right:
        // Amount - Discount = Sub-total, plus the taxes = Total.
        const discount = parseFloat(quotation.total_discount_amount) || 0;
        const subTotal = parseFloat(quotation.sub_total) || 0;
        return {
          no: index + 1,
          quotation_date: quotation.quotation_date,
          expiry_date: quotation.expiry_date,
          quotation_number: quotation.quotation_number,
          client_name: quotation.client?.business_name,
          amount: subTotal + discount,
          discount: discount,
          sub_total: subTotal,
          // vat_amount is Tax/Vat 1, tax1_amount is Tax/Vat 2 - the API field
          // names are off by one against the labels the app has always used.
          tax1: parseFloat(quotation.vat_amount) || 0,
          tax2: parseFloat(quotation.tax1_amount) || 0,
          total: parseFloat(quotation.total_amount_net) || 0,
          status: status,
          status_color: this.xlsStatusColor(status),
          note: hasNote ? "View" : "",
          attachment: hasFile ? "View" : "",
          _quotation_number: quotation.quotation_number,
        };
      });
    },
    xlsTotals() {
      // Summed off the rendered rows so every money column adds up against
      // what is actually on screen.
      return this.xlsColumns.reduce((totals, column) => {
        if (column.total) {
          totals[column.key] = this.xlsRows.reduce(
            (sum, row) => sum + (parseFloat(row[column.key]) || 0),
            0
          );
        }
        return totals;
      }, {});
    },
  },
};
</script>

<style scoped>
/* Status badges are informational only - keep the default arrow cursor.
   !important is needed to beat the global `a { cursor: pointer !important }`. */
.log-status,
.log-status * {
  cursor: default !important;
}
.expenses-list-body .expenses-list-single {
  min-height: 150px;
}
.custom-scroll {
  max-height: calc(100vh - 280px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 5px;
}
.custom-scroll::-webkit-scrollbar {
  width: 6px;
}
.custom-scroll::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
.custom-scroll::-webkit-scrollbar-thumb {
  background: #888; 
  border-radius: 4px;
}
.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

/* The XLS grid scrolls horizontally inside its own wrapper. Bootstrap columns
   are flex items with `min-width: auto`, so without this the 900px-wide grid
   stretches the column and overflows the page instead of scrolling. */
.xls-grid-col {
  min-width: 0;
  overflow: hidden;
}
</style>
